import React, { memo, useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
// Component
import UnreadText from '../../../components/UnreadText/UnreadText'
import { EmptyText } from '../../../components/Common/CellText'
import PageTitle from '../../../components/PageTitle'
import TableComponent from '../../../components/Common/TableComponent'
import AppPageHeader from '../../../components/AppPageHeader'
// Layout
import InternalMessageLayout from '../../../layouts/InternalMessageLayout'
// styled Component
import {
  SearchBar,
  TableActionWrapper,
  TableFooterActionWrapper,
} from './InternalMessageReceivePageStyled'
// Ant design
import { Button, Col, Empty, Input, message, Pagination, Row } from 'antd'
import { PlusOutlined, PlusCircleOutlined } from '@ant-design/icons'
//other
import { inject, observer } from 'mobx-react'
import { useLocation, withRouter } from 'react-router-dom'
import moment from 'moment'
import {
  ACL_ACTION_TYPE,
  WARNING_MESSAGE,
  YYYY_MM_DD_HH_mm,
} from '../../../constants'
import queryString from 'query-string'
import AccessControlAction from '../../../components/AccessControlAction'
import InternalMessageCreateModal from '../InternalMessageCreateModal'
import NormalTag from '../../../components/NormalTag/NormalTag'
import utils from '../../../utils'
import { systemName } from '../../../config'
import useCheckPageAccess from '../../../components/AccessPageAction/CheckPageAccess'

const { Search } = Input

const InternalMessageRecievesPage = props => {
  const {
    history,
    internalMessageStore,
    loadingAnimationStore,
    aclStore,
    authenticationStore,
  } = props

  const {
    internalMessageList,
    internalMessageListTotalCount,
    queryParams,
  } = internalMessageStore
  const { aclActionsByUser } = aclStore
  const { isAccountAdmin } = authenticationStore

  const location = useLocation()
  const queryStringParse = queryString.parse(location.search)

  const [isModalVisible, setIsModalVisible] = useState(false)
  // check hiển thị phân trang khi load dữ liệu
  const [checkPagination, setCheckPagination] = useState(true)

  // Check page access
  useCheckPageAccess({
    history,
    aclActionsByUser,
    isAccountAdmin,
    actionCode: ACL_ACTION_TYPE.menu__TIN_NHAN_NOI_BO,
  })

  const NGUOI_GUI_WIDTH = 200
  const NGAY_DEN_WIDTH = 100
  const TIEU_DE_WIDTH = 700
  const SCROLL_WIDTH = 1000

  const tableColumns = useMemo(
    () => [
      {
        title: 'Người gửi',
        width: NGUOI_GUI_WIDTH,
        render: record => (
          <>
            {record.owner_name ? (
              <NormalTag
                noHover={true}
                showFullTag={false}
                tags={[{ name: record.owner_name }].map(user =>
                  utils.getNameInCapitalize(user?.name?.toLowerCase())
                )}
              />
            ) : (
              <EmptyText>Không rõ</EmptyText>
            )}
          </>
        ),
      },
      {
        title: 'Tiêu đề',
        width: TIEU_DE_WIDTH,
        render: record => (
          <UnreadText
            text={record.title}
            isUnread={checkUnread(record)}
            width={TIEU_DE_WIDTH}
          />
        ),
      },
      {
        title: 'Ngày gửi',
        width: NGAY_DEN_WIDTH,
        render: record => (
          <UnreadText
            text={moment(record.created_time).format(YYYY_MM_DD_HH_mm)}
            isUnread={checkUnread(record)}
            width={NGAY_DEN_WIDTH}
          />
        ),
      },
    ],
    []
  )

  const checkUnread = record => !record.is_read

  const handleQuickSearch = keyword => {
    const queryStringStringify = queryString.stringify({
      ...queryStringParse,
      page: 0,
      size: 10,
      keyword: keyword ? keyword.trim() : null,
    })
    history.replace(`/utility/internal-message/receive?${queryStringStringify}`)
  }

  const onChangePagination = pageIndex => {
    internalMessageStore.setQueryParams({
      ...queryParams,
      page: pageIndex - 1,
      size: 10,
    })
    const queryStringStringify = queryString.stringify({
      ...queryStringParse,
      page: pageIndex - 1,
      size: 10,
    })
    history.replace(`/utility/internal-message/receive?${queryStringStringify}`)
  }

  const getInternalMessageReceiveList = async () => {
    try {
      let localQueryStringParse = {
        page: 0,
        size: 10,
        ...queryStringParse,
      }
      loadingAnimationStore.setTableLoading(true)
      await setCheckPagination(false)
      await internalMessageStore.getInternalMessageReceiveList(
        localQueryStringParse
      )
    } catch (error) {
      console.log(error)
      message.error(error?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.setTableLoading(false)
      setCheckPagination(true)
    }
  }

  useEffect(() => {
    ;(async () => {
      await getInternalMessageReceiveList()
    })()
  }, [location])

  return (
    <InternalMessageLayout
      title={
        <AppPageHeader
          title="Tin nhắn đến"
          addon={
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Search
                size="large"
                className="rounded-search"
                style={{ width: 300 }}
                allowClear
                onSearch={value => handleQuickSearch(value)}
                defaultValue={queryStringParse.keyword}
                placeholder={'Tìm kiếm tin nhắn theo tiêu đề'}
              />
              <AccessControlAction
                aclActionType={ACL_ACTION_TYPE.send__TIN_NHAN_NOI_BO}>
                <Button
                  size="large"
                  icon={<PlusCircleOutlined />}
                  onClick={() => setIsModalVisible(true)}
                  type={'primary'}>
                  Gửi tin nhắn
                </Button>
              </AccessControlAction>
            </div>
          }
        />
      }
      selectedKey="receive"
      linkToInternalMessageRecieve="/utility/internal-message/receive"
      linkToInternalMessageSend="/utility/internal-message/send">
      <Helmet>
        <title>Tạo mới tin nhắn | {systemName} Quản lý Tin nhắn</title>
      </Helmet>
      <TableActionWrapper>
        <TableComponent
          onRow={record => {
            return {
              onClick: () =>
                history.push(
                  `/utility/internal-message/receive/view/${record.code}`
                ),
            }
          }}
          rowKey={record =>
            record.code
              ? record.code + Math.random() * 1000
              : Math.random() * 1000
          }
          dataSource={internalMessageList}
          columns={tableColumns}
          pagination={false}
          scroll={{ x: SCROLL_WIDTH }}
          locale={{
            emptyText:
              checkPagination === true ? (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={'Không có dữ liệu'}
                />
              ) : (
                <div style={{ opacity: 0.1, height: '150px' }} />
              ),
          }}
          loading={{
            tip: 'Đang tải tin nhắn...',
            spinning: loadingAnimationStore.tableLoading,
          }}
        />
        <TableFooterActionWrapper>
          {checkPagination === true ? (
            <Pagination
              onChange={e => onChangePagination(e)}
              hideOnSinglePage={true}
              total={internalMessageListTotalCount}
              pageSize={queryParams.size}
              current={queryParams.page + 1}
              showSizeChanger={false}
              showLessItems
            />
          ) : (
            ''
          )}
        </TableFooterActionWrapper>
      </TableActionWrapper>
      <InternalMessageCreateModal
        isModalVisible={isModalVisible}
        handleCloseCreateModal={isRefressList => {
          setIsModalVisible(false)
          if (isRefressList) {
            getInternalMessageReceiveList()
          }
        }}
      />
    </InternalMessageLayout>
  )
}

InternalMessageRecievesPage.propTypes = {}

export default memo(
  withRouter(
    inject(
      'internalMessageStore',
      'loadingAnimationStore',
      'authorityStore',
      'selectUserStore',
      'userStore',
      'aclStore',
      'authenticationStore'
    )(observer(InternalMessageRecievesPage))
  )
)
